import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import type { GlobalState } from "../../store";
import type { PaymentPlansType } from "@/types";

const initialState: PaymentPlansType[] = [];

export const paymentPlansState = createSlice({
  name: "paymentPlans",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<PaymentPlansType[]>) => {
      return action.payload;
    },
  },
});

const selector = (s: GlobalState) => s.data.purchaseSeats.paymentPlans;
export const selectPaymentPlans = createSelector(selector, (s) => s);
export const selectPaymentPlanSelected = createSelector(selector, (s) =>
  s.find((itm) => itm.selected)
);
export default paymentPlansState.reducer;
